/**
 * MODO TV — a chave que liga a adaptação para televisão.
 *
 * ⚠️ POR QUE ISTO É UMA CHAVE, E NÃO ESPALHADO PELO CÓDIGO
 * O mesmo código serve o telefone, o desktop, o WebView do Android E, no futuro, a TV.
 * Navegação por controle remoto, layout de 3 metros e foco visível SÃO só da TV — na tela
 * de toque eles atrapalhariam. Então tudo que é de TV fica atrás deste `isTV`. Em
 * telefone/desktop `isTV` é `false`, e NADA muda: o app de toque continua idêntico.
 *
 * Como liga:
 *   - `REACT_APP_TV=1` no build de TV (o jeito certo — build dedicado).
 *   - senão, pelo user-agent das TVs conhecidas (pra funcionar num webview de TV sem flag).
 *   - `?tv=1` na URL ajuda a TESTAR o modo TV num navegador comum.
 */
const UA = typeof navigator !== "undefined" ? navigator.userAgent : "";
const forcadoPelaUrl =
  typeof window !== "undefined" && /[?&]tv=1\b/.test(window.location.search);

export const isTV =
  process.env.REACT_APP_TV === "1" ||
  forcadoPelaUrl ||
  // Tizen (Samsung), webOS (LG), Android TV / Google TV, Apple TV, Chromecast, Fire TV
  /Tizen|Web0S|webOS|SmartTV|SMART-TV|AppleTV|CrKey|GoogleTV|Android ?TV|BRAVIA|AFT[A-Z]/i.test(UA);
